export const eChart = {
  myChartArray: [],
  lineAndColumn: function (el, lineData, barData, categoryData, str) {
    // Generate data
    let category = categoryData
    var lineData = lineData
    var barData = barData
    var rateData = []
    for (let i = 0; i < 33; i++) {
      // var date = i+2001;
      // category.push(date)
      var rate = barData[i] / lineData[i]
      rateData[i] = rate.toFixed(2)
    }
    let myChart = window.echarts.init(document.getElementById(el))
    myChart.clear()
    let option = {
      // title: {
      //   text: '增量设备贯通情况-单位',
      //   x: 'center',
      //   y: 0,
      //   textStyle: {
      //     color: '#B4B4B4',
      //     fontSize: 16,
      //     fontWeight: 'normal',
      //   },
      //
      // },
      backgroundColor: '#FFF',
      tooltip: {
        trigger: 'axis',
        backgroundColor:'none',
        formatter: function (params) {
          let itemName = params[0].name
          let string = `<div style="min-width: 200px;padding: 16px;background:rgba(255,255,255,1);opacity:0.85;border-radius:6px;box-shadow: 0 0 10px rgba(164,164,164,.45)">
                <p style="color: #1C1D1F;">${itemName}</p>`
          for (let i = 0; i < params.length; i++) {
            string +=
              `<p style="display: flex;justify-content: space-between;align-items: center;margin-top: 5px;color:#697280;font-size:12px;">
                  <span style="display: flex;justify-content: space-between;align-items: center">
                    <span style="display: inline-block;width: 6px;height: 6px;border-radius: 50%;background:  ${params[i].color.colorStops?params[i].color.colorStops[0].color:params[i].color};margin-right: 8px;"></span>
                    ${params[i].seriesName}
                  </span>
                  <span>
                    ${params[i].value}
                  </span>
                </p>`
          }
          return string
        },
        axisPointer: {
          type: 'line',
          label: {
            show: false,
            backgroundColor: '#7B7DDC'
          },
          lineStyle: {
            color:'rgb(212,223,231)',
            opacity: 0.5
          }
        }
      },
      legend: {
        data: [str + '人数', str + '总人数',],
        textStyle: {
          color: '#B4B4B4'
        },
        top: '0',
      },
      // grid: {
      //   x: '12%',
      //   width: '82%',
      //   y: '12%',
      // },
      xAxis: {
        data: category,
        axisLine: {
          lineStyle: {
            color: '#B4B4B4'
          }
        },
        axisTick: {
          show: false,
        },
      },
      yAxis: [{

        splitLine: {show: false},
        axisLine: {
          lineStyle: {
            color: '#B4B4B4',
          }
        },

        axisLabel: {
          formatter: '{value} ',
        }
      },
        {

          splitLine: {show: false},
          axisLine: {
            lineStyle: {
              color: '#B4B4B4',
            }
          },
          axisLabel: {
            formatter: '{value} ',
          }
        }],
      grid: {
        left: 58,
        top: 40,
        right: 58,
        bottom: 20
      },
      series: [{
        name: str + '总人数',
        type: 'line',
        smooth: true,
        showAllSymbol: false,
        symbol: 'emptyCircle',
        symbolSize: 8,
        yAxisIndex: 1,
        itemStyle: {
          normal: {
            color: 'rgba(131, 179, 235, 1)'
          },
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: 'rgba(131, 179, 235, 1)'
          }, {
            offset: 1,
            color: 'rgba(255, 255, 255,0.15)'
          }])
        },
        data: lineData
      },

        {
          name: str + '人数',
          type: 'bar',
          barMaxWidth: 20,
          itemStyle: {
            normal: {
              barBorderRadius: 0,
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  {offset: 0, color: '#2E80DE'},
                  {offset: 1, color: '#8BC7FD'}
                ]
              )
            }
          },
          data: barData
        },

      ]
    }
    // 使用刚指定的配置项和数据显示图表。
    this.myChartArray.push(myChart)
    myChart.setOption(option)
    myChart.resize()

  },
  AnotherLineAndColumn: function (el, lineData, barData, categoryData, anotherLineData, anotherBarData, str, year) {
    // Generate data
    var rateData = []
    for (let i = 0; i < 33; i++) {
      // var date = i+2001;
      // category.push(date)
      var rate = barData[i] / lineData[i]
      rateData[i] = rate.toFixed(2)
    }
    let myChart = window.echarts.init(document.getElementById(el))
    myChart.clear()
    let option = {
      // title: {
      //   text: '增量设备贯通情况-单位',
      //   x: 'center',
      //   y: 0,
      //   textStyle: {
      //     color: '#B4B4B4',
      //     fontSize: 16,
      //     fontWeight: 'normal',
      //   },
      //
      // },
      backgroundColor: '#FFF',
      tooltip: {
        trigger: 'axis',
        backgroundColor:'none',
        formatter: function (params) {
          let itemName = params[0].name
          let string = `<div style="min-width: 240px;padding: 16px;background:rgba(255,255,255,1);opacity:0.85;border-radius:6px;box-shadow: 0 0 10px rgba(164,164,164,.45)">
                <p style="color: #1C1D1F;">${itemName}</p>`
          for (let i = 0; i < params.length; i++) {
            string +=
              `<p style="display: flex;justify-content: space-between;align-items: center;margin-top: 5px;color:#697280;font-size:12px;">
                  <span style="display: flex;justify-content: space-between;align-items: center">
                    <span style="display: inline-block;width: 6px;height: 6px;border-radius: 50%;background:  ${params[i].color.colorStops?params[i].color.colorStops[0].color:params[i].color};margin-right: 8px;"></span>
                    ${params[i].seriesName}
                  </span>
                  <span>
                    ${params[i].value}
                  </span>
                </p>`
          }
          return string
        },
        axisPointer: {
          type: 'line',
          label: {
            show: false,
            backgroundColor: '#7B7DDC'
          },
          lineStyle: {
            color:'rgb(212,223,231)',
            opacity: 0.5
          }
        }
      },
      legend: {
        data: [str + '人数', str + '总人数', year + '同期' + str + '人数', year + '同期' + str + '总人数'],
        textStyle: {
          color: '#B4B4B4'
        },
        top: '0',
      },
      // grid: {
      //   x: '12%',
      //   width: '82%',
      //   y: '12%',
      // },
      xAxis: {
        data: categoryData,
        axisLine: {
          lineStyle: {
            color: '#B4B4B4'
          }
        },
        axisTick: {
          show: false,
        },
      },
      yAxis: [{

        splitLine: {show: false},
        axisLine: {
          lineStyle: {
            color: '#B4B4B4',
          }
        },

        axisLabel: {
          formatter: '{value} ',
        }
      },
        {

          splitLine: {show: false},
          axisLine: {
            lineStyle: {
              color: '#B4B4B4',
            }
          },
          axisLabel: {
            formatter: '{value} ',
          }
        }],
      grid: {
        left: 58,
        top: 40,
        right: 58,
        bottom: 20
      },
      series: [
        {
          name: str + '总人数',
          type: 'line',
          smooth: true,
          showAllSymbol: false,
          symbol: 'emptyCircle',
          symbolSize: 8,
          yAxisIndex: 1,
          itemStyle: {
            normal: {
              color: 'rgba(131, 179, 235, 1)'
            },
          },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: 'rgba(131, 179, 235, 1)'
            }, {
              offset: 1,
              color: 'rgba(255, 255, 255,0.15)'
            }])
          },
          data: lineData
        },
        {
          name: year + '同期' + str + '总人数',
          type: 'line',
          smooth: true,
          showAllSymbol: false,
          symbol: 'emptyCircle',
          symbolSize: 8,
          yAxisIndex: 1,
          itemStyle: {
            normal: {
              color: 'rgba(82, 228, 178, 1)'
            },
          },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: 'rgba(82, 228, 178, 1)'
            }, {
              offset: 1,
              color: 'rgba(255, 255, 255,0.15)'
            }])
          },
          data: anotherLineData
        },

        {
          name: str + '人数',
          type: 'bar',
          stack: '堆叠',
          barMaxWidth: 20,
          itemStyle: {
            normal: {
              barBorderRadius: 0,
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  {offset: 0, color: '#2E80DE'},
                  {offset: 1, color: '#8BC7FD'}
                ]
              )
            }
          },
          data: barData
        },
        {
          name: year + '同期' + str + '人数',
          type: 'bar',
          barMaxWidth: 20,
          barGap: '-100%',
          stack: '堆叠',
          itemStyle: {
            normal: {
              barBorderRadius: 0,
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  {offset: 0, color: 'rgba(82, 228, 178, 1)'},
                  {offset: 1, color: 'rgba(184, 248, 226, 1)'}
                ]
              )
            }
          },
          data: anotherBarData
        },
      ]
    }
    // 使用刚指定的配置项和数据显示图表。
    this.myChartArray.push(myChart)
    myChart.setOption(option)
    myChart.resize()

  },
  pies:function (el,name,complete,noComplete,darkColor,lightColor) {
    let myChart = window.echarts.init(document.getElementById(el))
    myChart.clear()
    let option = {
      tooltip: {
        trigger: 'item',
        formatter: "{a} <br/>{b} : {c} ({d}%)"
      },
      series: [{
        name,
        type: 'pie',
        radius: '85%',
        center: ['50%', '50%'],
        clockwise: false,
        data: [{
          value: noComplete,
          name: '未完成'
        }, {
          value: complete,
          name: '完成'
        }],
        label: {
          normal: {
            position:'inside',
            formatter:(params)=>{
              if(params.name === '未完成'){
                return ''
              }else {
                return params.name +"人数"
              }
            },
            textStyle: {
              color: 'rgba(255, 255, 255, 1)',
              fontSize: 12,
            }
          }
        },
        labelLine: {
          normal: {
            show: false
          }
        },
        itemStyle: {
          normal: {
            borderWidth: 4,
            borderColor: '#ffffff',
          },
          emphasis: {
            borderWidth: 0,
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          }
        }
      }],
      color: [
        'rgba(227, 237, 248, 1)',
        {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
            offset: 0, color: darkColor // 0% 处的颜色
          }, {
            offset: 1, color: lightColor // 100% 处的颜色
          }],
          global: false // 缺省为 false
        }
      ],
      backgroundColor: '#fff'
    };
    // 使用刚指定的配置项和数据显示图表。
    this.myChartArray.push(myChart)
    myChart.setOption(option)
    myChart.resize()
  },
  AnotherPies:function (el,name,darkColor,lightColor,data_list) {
    let data = []
    data_list.map((item,index)=>{
      data.push(
        {
          value: item.finish_count,
          name: item.grade
        }
      )
    })
    let myChart = window.echarts.init(document.getElementById(el))
    myChart.clear()
    let option = {
      tooltip: {
        trigger: 'item',
        formatter: "{a} <br/>{b} : {c} ({d}%)"
      },
      series: [{
        name,
        type: 'pie',
        radius: '85%',
        center: ['50%', '50%'],
        clockwise: false,
        // data: [{
        //   value: 1,
        //   name: '基础'
        // }, {
        //   value: 2,
        //   name: '待加强'
        // }, {
        //   value: 3,
        //   name: '精熟'
        // }],
        data:data,
        label: {
          normal: {
            position:'inside',
            formatter:(params)=>{
              if(params.name === '未完成'){
                return ''
              }else {
                return params.name +"人数"
              }
            },
            textStyle: {
              color: 'rgba(255, 255, 255, 1)',
              fontSize: 12,
            }
          }
        },
        labelLine: {
          normal: {
            show: false
          }
        },
        itemStyle: {
          normal: {
            borderWidth: 4,
            borderColor: '#ffffff',
          },
          emphasis: {
            borderWidth: 0,
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          }
        }
      }],
      color: [
        'rgba(227, 237, 248, 1)',
        {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
            offset: 0, color: darkColor // 0% 处的颜色
          }, {
            offset: 1, color: lightColor // 100% 处的颜色
          }],
          global: false // 缺省为 false
        }
      ],
      backgroundColor: '#fff'
    };
    // 使用刚指定的配置项和数据显示图表。
    this.myChartArray.push(myChart)
    myChart.setOption(option)
    myChart.resize()
  },

}